import React, {Component} from 'react';
import CampaignGuidelinesListZoid from './campaign_guidelines_list_zoid';
import './index.scss';

class CampaignGuidelinesListEmbed extends Component {
    constructor(props) {
        super(props);
    }

    state = {
        zoidIframeHeight: undefined,
        isDataReady: false
    };

    onZoidIframeResize = windowSize => {
        // This function gets passed to the source iframe component and can respond properly when the size of the content in the iframe changes.
        // This is important for proper scrolling behavior for the iframe
        if (windowSize.height !== this.state.zoidIframeHeight) {
            this.setState({
                zoidIframeHeight: windowSize.height
            });
        }
    };

    onDataReadyStateChange = isDataReady => {
        this.setState({
            isDataReady
        });
    };

    prerender = () => {
        return (
            <div className="snclient-campaign-guidelines-list_prerender">
                <div>Loading the guidelines</div>
            </div>
        );
    };

    render() {
        return (
            <div
                className={'snclient-campaign-guidelines-list-embedded'}
                style={{
                    minHeight: `400px`,
                    height: `${this.state.zoidIframeHeight}px`
                }}
            >
                {!this.state.zoidIframeHeight && this.prerender()}
                <CampaignGuidelinesListZoid
                    onContentResize={this.onZoidIframeResize}
                    onDataReadyStateChange={this.onDataReadyStateChange}
                    {...this.props}
                />
            </div>
        );
    }
}
export default CampaignGuidelinesListEmbed;



// WEBPACK FOOTER //
// ./components/campaign_guidelines_embed/index.js